// extracted by mini-css-extract-plugin
export default {"reviews-empty-state":"_1elfcs7","reviewsEmptyState":"_1elfcs7"};